import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import axiosInstance from '../axiosInterceptor'
import { toast } from 'react-toastify'
import { ImageLink } from '../constants'
import CommonEditor from './CommonEditor'

const AddProjectContact = () => {
    const navigator = useNavigate();
    const location = useLocation();
    const editData = location.state

    const [projectData, setProjectData] = useState([]);

    const [data, setData] = useState({
        projectId: editData?.projectId._id || '',
        address: editData?.address || '',
        mapUrl: editData?.mapUrl || '',
        phone: editData?.phone || '',
        email: editData?.email || '',
        brochurePdf: editData?.brochurePdf || '',
    });

    const [errors, setErrors] = useState({
        projectId: '',
        address: '',
        mapUrl: '',
        phone: '',
        email: '',
        brochurePdf: '',
    });

    const handleChange = (e) => {
        const { name, files, value } = e.target;
        if (name === 'brochurePdf' && files.length > 0) {
            const file = files[0];
            if (file.type !== 'application/pdf') {
                return toast.error('Only PDF files are allowed ');
            }
            setData({ ...data, [name]: file });
        } else {
            setData({ ...data, [name]: value });
        }
        setErrors({ ...errors, [name]: '' });
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        let hasErrors = false;

        // Validate email
        if (!data.projectId.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                projectId: 'Project is required'
            }));
            hasErrors = true;
        }
        if (!data.address.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                address: 'Address is required'
            }));
            hasErrors = true;
        }
        if (!data.mapUrl.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                mapUrl: 'Map url is required'
            }));
            hasErrors = true;
        }
        if (!data.phone.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                phone: 'Phone number is required'
            }));
            hasErrors = true;
        }
        if (!data.email) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                email: 'Email is required'
            }));
            hasErrors = true;
        }
        // if (!data.brochurePdf) {
        //     setErrors((prevErrors) => ({
        //         ...prevErrors,
        //         brochurePdf: 'Pdf is required'
        //     }));
        //     hasErrors = true;
        // }

        // If there are errors, stop further processing
        if (hasErrors) {
            return;
        }

        try {
            const formData = new FormData();
            formData.append("projectId", data.projectId);
            formData.append("address", data.address);
            formData.append("mapUrl", data.mapUrl);
            formData.append("phone", data.phone);
            formData.append("email", data.email);
            if (data.brochurePdf instanceof File) {
                formData.append("brochurePdf", data.brochurePdf);
            }

            const response = await axiosInstance.post(`project/createProjectContact`, formData);
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator("/project-contact");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };
    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append("projectId", data.projectId);
            formData.append("address", data.address);
            formData.append("mapUrl", data.mapUrl);
            formData.append("phone", data.phone);
            formData.append("email", data.email);
            if (data.brochurePdf instanceof File) {
                formData.append("brochurePdf", data.brochurePdf);
            }

            const response = await axiosInstance.put(`project/updateProjectContact/${editData?._id}`, formData);
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator("/project-contact");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };

    const fetchData = async () => {
        try {
            const response = await axiosInstance.get(`project/getWithoutPaginationProject`);
            const { data } = response.data;
            setProjectData(data);
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };

    useEffect(() => {
        fetchData();
    }, []);


    return (
        <>
            <div className="content-wrapper">
                <div className="page-header mt-5">
                    <h3 className="page-title">Add Project Contact</h3>
                </div>
                <div className="row grid-margin stretch-card">
                    <div className="col-md-8  ">
                        <div className="card">
                            <div className="card-body">
                                <form className="pt-3" onSubmit={editData?._id ? handleUpdate : handleSubmit}>
                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername1"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Project
                                        </label>
                                        <div className="col-sm-9">
                                            <select
                                                className="form-control form-control-lg"
                                                id="exampleFormControlSelect1"
                                                name='projectId'
                                                value={data.projectId}
                                                onChange={handleChange}
                                            >
                                                <option value="" disabled>-- Please Select Project --</option>
                                                {projectData.map(item => (
                                                    <option key={item._id} value={item._id}>{item.title}</option>
                                                ))}
                                            </select>
                                            {errors.projectId && <p className="text-danger">{errors.projectId}</p>}
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Head Office
                                        </label>
                                        <div className="col-sm-9">
                                            {/* <textarea
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="address"
                                                name="address"
                                                placeholder="Enter head office address"
                                                value={data.address}
                                                onChange={handleChange}
                                                style={{ height: '150px' }}
                                            />
                                            {errors.address && <p className="text-danger">{errors.address}</p>} */}
                                            <CommonEditor
                                                value={data.address}
                                                placeholder='Enter content ...'
                                                onChange={(value) => handleChange({ target: { name: 'address', value } })}
                                            />
                                            {errors.address && !data?.content?.trim() && (
                                                <div className="text-danger">Address is required</div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Contact Email
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="email"
                                                name="email"
                                                placeholder="Enter email"
                                                value={data.email}
                                                onChange={handleChange}
                                            />
                                            {errors.email && <p className="text-danger">{errors.email}</p>}
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Contact Number
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="phone"
                                                name="phone"
                                                placeholder="Enter number"
                                                value={data.phone}
                                                onChange={handleChange}
                                            />
                                            {errors.phone && <p className="text-danger">{errors.phone}</p>}
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Office Map Url
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="mapUrl"
                                                name="mapUrl"
                                                placeholder="Enter office map url"
                                                value={data.mapUrl}
                                                onChange={handleChange}
                                            />
                                            {errors.mapUrl && <p className="text-danger">{errors.mapUrl}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            for="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Upload Brochure
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="file"
                                                className="form-control form-control-sm"
                                                id="brochurePdf"
                                                name="brochurePdf"
                                                onChange={handleChange}
                                            />
                                            {/* {errors.brochurePdf && <p className="text-danger">{errors.brochurePdf}</p>} */}
                                        </div>
                                    </div>
                                    <div className='text-center mt-4'>
                                        <Link to="/project-contact"><button className="btn btn-secondary mr-2">
                                            Back </button></Link>
                                        <button type="submit" className="btn btn-success">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 stretch-card">
                        <div className="card">
                            {data.brochurePdf &&
                                <div className="w-100 h-80 text-center mb-4">
                                    <p className="mt-3">Pdf Preview</p>
                                    <br />
                                    {data.brochurePdf instanceof File ? (
                                        <Link to={URL.createObjectURL(data?.brochurePdf)} target="_blank">
                                            <img src="images/icon/pdf.png" alt="pdf" className="ms-3 me-3" width={60} />
                                        </Link>
                                    ) : (
                                        <Link to={ImageLink(data?.brochurePdf)} target="_blank">
                                            <img src="images/icon/pdf.png" alt="pdf" className="ms-3 me-3" width={60} />
                                        </Link>
                                    )}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddProjectContact;